var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"t",domProps:{"innerHTML":_vm._s(_vm.$app.secure.clean(_vm.$n.t(_vm.name)))}})
}
var staticRenderFns = []

export { render, staticRenderFns }